function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "path-161486780740862095",
  d: "M0 2 C0 0.8954305004 0.8954305003999999 0 1.9999999999999998 0 C1.9999999999999998 0 27.000000000000004 0 27.000000000000004 0 C28.104569499600004 0 29.000000000000004 0.8954305004 29.000000000000004 2 C29.000000000000004 2 29.000000000000004 2 29.000000000000004 2 C29.000000000000004 3.1045694996 28.104569499600004 4 27.000000000000004 4 C27.000000000000004 4 1.9999999999999998 4 1.9999999999999998 4 C0.8954305004 4 0 3.1045694996 0 2 C0 2 0 2 0 2 Z",
  vectorEffect: "non-scaling-stroke"
}));

function SvgRectangle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 29 4",
    width: 29,
    height: 4,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, _ref2, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2 C0 0.8954305004 0.8954305003999999 0 1.9999999999999998 0 C1.9999999999999998 0 27.000000000000004 0 27.000000000000004 0 C28.104569499600004 0 29.000000000000004 0.8954305004 29.000000000000004 2 C29.000000000000004 2 29.000000000000004 2 29.000000000000004 2 C29.000000000000004 3.1045694996 28.104569499600004 4 27.000000000000004 4 C27.000000000000004 4 1.9999999999999998 4 1.9999999999999998 4 C0.8954305004 4 0 3.1045694996 0 2 C0 2 0 2 0 2 Z",
    style: {
      stroke: "rgb(140, 140, 140)",
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      fill: "rgb(221, 221, 221)"
    },
    vectorEffect: "non-scaling-stroke"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle);
export default __webpack_public_path__ + "static/media/rectangle.1e90aec4.svg";
export { ForwardRef as ReactComponent };